let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("82tlz")).then(() => parcelRequire('6daub'));